export interface FieldRestriction {
	type: 'gt' | 'ls' | 'eq' | 'neq' | 'contains' | 'is-falsy' | 'is-truly'
	field: string
	value: string | number
}

export interface RowRestriction {
	type: 'rows-gt' | 'rows-ls' | 'rows-eq' | 'rows-neq'
	value: number
}

export interface IQueryFieldsItem {
	field: string,
	type: string
}

export type ConditionType = 'boolean' | 'date' | 'text' | 'number' | 'sql';

export interface Column {
	name: string;
	type: ConditionType;
}

export interface ICondition {
	type: ConditionType;
	columns?: Column[];
	required: boolean;
	value: string | boolean | number | null;
}

export type ReportBlockType = 'table' | 'bar' | 'line' | 'pie';

/** Bloco do relatório anexado. `source` = key da consulta/cruzamento ('resultado' no observador comum) */
export interface ReportBlock {
	type: ReportBlockType
	source: string
	title?: string
	/** tabela: colunas exibidas (vazio = todas) e quantidade de linhas */
	columns?: string[]
	limit?: number
	/** gráfico: coluna do rótulo e colunas de valor */
	label?: string
	values?: string[]
}

export interface ReportQuery {
	key: string
	sql: string
	fields: IQueryFieldsItem[]
}

/** Cruzamento de duas consultas por uma coluna; colunas resultantes ficam prefixadas (`vendas.total`) */
export interface ReportJoin {
	key: string
	left: string
	leftOn: string
	right: string
	rightOn: string
	type: 'inner' | 'left'
}

/** Com `queries` o observador é um grupo de consultas (sem gatilho, sempre notifica) */
export interface ObserverReport {
	queries?: ReportQuery[]
	joins?: ReportJoin[]
	blocks: ReportBlock[]
}

export const OBSERVER_REPORT_SOURCE = 'resultado';

export const isQueryGroup = (observer: Pick<Observer, 'report'>) => !!observer.report?.queries?.length;

export interface Observer {
	observer_id: string;
	client_id: string | number;
	name: string;
	short_name: string;
	sql_url: string | null;
	/** Texto do SQL (campo virtual retornado pelo GET /observers/:id e aceito no PATCH) */
	sql?: string | null;
	is_active: boolean;
	custom_preview_message: string;
	periodicity_id: string;
	severity_id: string | null;
	field_restrictions: FieldRestriction[]
	row_restrictions: RowRestriction[]
	creation_date: string
	tags: string[]
	flags: string[]
	module_id: string | null
	module_sql_url: string | null
	sql_test_result: IQueryFieldsItem[]
	conditions: Record<string, ICondition> | null
	org_id: string;
	last_execution?: string
	report?: ObserverReport | null
}